module.exports = SharedDependencies.ReactDOM['@servicetitan/cpb-host'];